import { render } from "./SettingNotification.vue?vue&type=template&id=890cf30c&scoped=true&ts=true"
import script from "./SettingNotification.vue?vue&type=script&lang=ts"
export * from "./SettingNotification.vue?vue&type=script&lang=ts"

import "./SettingNotification.vue?vue&type=style&index=0&id=890cf30c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890cf30c"]])

export default __exports__